import { appProvideKey } from "@/utils/vue-app";
import { inject } from "vue";

export function useVueApp() {
  return inject(appProvideKey)!;
}
